import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader
} from "../../../_metronic/_partials/controls";
import { Button, Accordion } from "react-bootstrap";
import moment from "moment";

import { Link } from "react-router-dom";

import "./ContestList.css";
import { FaDollarSign} from 'react-icons/fa';
import { imageUrl } from "../../components/UIHelpers";

export default function TournamentSummeryDetails(props) {
  const dispatch = useDispatch();

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const {
    tournamentForEdit
  } = currentState;

  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
      {(item.currencyAry && item.currencyAry.symbol==="$") ? (
        <span className="font-weight-bold" style={{color: "#000000",fontSize:"1.1em"}}><FaDollarSign /></span>
        
        ) : ( item.currencyAry && item.currencyAry.img ? (
            <img
              className="currency"
              // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currencyAry.img.default}`}
              src={imageUrl(item.currencyAry.img.default)}
              alt="currency"
            />
          ) : (
            <span className="text-dark-50 font-weight-bold">₹ </span>
          )
        )}
      </span>
    );
  };

  const viewItem = (id) => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/view/${id}`;
    window.open(url, "_blank");
  };

  return (
    <div className="">
      <div className="row">
        <div className="col-md-12">
          <div
            className={`card border-1 border-dark card-custom gutter-b mb-12`}
          >
            <div className="card-body">
              <div className="contest-title">{tournamentForEdit?.title}</div>
              <div className="d-flex">
                {/* <!--begin::Pic--> */}
                <div className="flex-shrink-0 mr-7">
                  <div className="symbol symbol-50 symbol-lg-120">
                    <img
                      alt="Pic"
                      // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${tournamentForEdit?.gameAry &&
                      //   tournamentForEdit?.gameAry?.featuredImage?.default}`}
                        src={imageUrl(tournamentForEdit?.gameAry && tournamentForEdit?.gameAry?.featuredImage?.default)}
                    />
                  </div>
                </div>
                {/* <!--end::Pic--> */}
                {/* <!--begin: Info--> */}
                <div className="flex-grow-1">
                  {/* <!--begin::Title--> */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    {/* <!--begin::User--> */}
                    <div className="mr-3">
                      {/* <!--begin::Name--> */}
                      <div href="#" className="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">
                        {tournamentForEdit?.gameAry?.name} - {tournamentForEdit?.gameTypeAry?.name}
                        <i className="flaticon2-correct text-success icon-md ml-2"></i>
                      </div>

                      <div href="#" className="text-dark text-hover-primary font-size-h5 font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                        {"For " + tournamentForEdit?.countriesAryString}
                      </div>

                      {/* <!--begin::Contacts--> */}
                      <div className="d-flex flex-wrap my-2">
                        {tournamentForEdit?.map ?
                          <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                              {/* <i className="flaticon2-location"></i>{" "} */}
                              Map:
                            </span>
                            {tournamentForEdit?.map}
                          </div>
                          : <></>}
                        {/* <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                  <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                    <i className="flaticon2-medal"></i> Prize
                                    Pool:
                                  </span>
                                  {tournamentForEdit?.prizePool}
                                </div>
                                <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                  Tournament Start - End Date Time :
                                </span>{" "}
                                {moment(tournamentForEdit?.startDate).format("MMM DD, YYYY hh:mm a")} - {moment(tournamentForEdit?.endDate).format("MMM DD, YYYY hh:mm a")}
                                </div>
                                <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                  Tournament Register Start - End Date Time :
                                </span>{" "}
                                  {moment(tournamentForEdit?.registrationStartDate).format("MMM DD, YYYY hh:mm a")} - {moment(tournamentForEdit?.registrationEndDate).format("MMM DD, YYYY hh:mm a")}
                                </div> */}
                      </div>

                      {/* <!--end::Contacts--> */}
                      {/* <!--end::Name--> */}
                    </div>
                    {/* <!--end::User--> */}
                    <div className="my-lg-0 my-1">
                      {props?.type != "team" ?
                        <Link to={`/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/teamList/${tournamentForEdit._id}`} target="_blank" className="btn mr-5 w-60px btn-sm btn-primary font-weight-bolder text-uppercase">
                          Team
                        </Link> :
                        <Link onClick={() => viewItem(tournamentForEdit._id)} className="btn w-60px btn-sm btn-primary font-weight-bolder text-uppercase">
                          View
                        </Link>
                      }
                    </div>
                  </div>
                  {/* <!--end::Title--> */}
                  {/* <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="d-flex flex-wrap my-2">
                              <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                  <i className={tournamentForEdit.status ? "flaticon2-check-mark text-success" : "flaticon2-cross text-danger"}></i>
                                </span>{" "}
                                Confirm
                              </div>
                              <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                  <i className={tournamentForEdit.visiblity ? "flaticon2-check-mark text-success" : "flaticon2-cross text-danger"}></i>
                                </span>{" "}
                                Public
                              </div>
                              <div href="#" className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                  <i className={tournamentForEdit.isFeacherd? "flaticon2-check-mark text-success": "flaticon2-cross text-danger"}></i>
                                </span>{" "}
                                Featured
                              </div>
                            </div>
                            {tournamentForEdit?.isActive === true ?
                            <div className="d-flex align-items-end flex-wrap justify-content-end">
                              <div className="d-flex mt-4 mt-sm-0">
                                <Button className="btn-sm  w-120px btn mb-lg-0 mb-2 text-uppercase btn-primary">
                                  Active
                                </Button>
                              </div>
                            </div>
                            :
                            <div className="d-flex align-items-end flex-wrap justify-content-end">
                              <div className="d-flex mt-4 mt-sm-0">
                                <Button className="btn-sm  w-120px btn mb-lg-0 mb-2 text-uppercase btn-danger">
                                  In-Active
                                </Button>
                              </div>
                            </div>
                            }
                          </div> */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex flex-wrap my-2">
                      {/* <span className="text-success text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span className="svg-icon text-muted svg-icon-md svg-icon-gray-500 mr-1">
                                  Assign to :
                                </span>{" "}
                                Valay Patel
                              </span> */}

                      <div className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                        <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                          ShortCode :
                        </span>{" "}
                        {tournamentForEdit?.shortCode}
                      </div>
                      <div className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                        <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                          Id :
                        </span>{" "}
                        {tournamentForEdit?._id}
                      </div>
                    </div>
                    {/* <!--begin::Progress--> */}
                    <div className="d-flex align-items-center flex-wrap justify-content-between">
                      {/* <div className="mt-4 mt-sm-0">
                                <div className="progress progress-xs mt-2 mb-2 flex-shrink-0 w-150px w-xl-250px">
                                  <div
                                    className="progress-bar bg-success"
                                    role="progressbar"
                                    style={{ width: `${parseInt(
                                      tournamentForEdit?.totalJoinedPlayers * 100
                                    ) /
                                      parseInt(
                                        tournamentForEdit?.totalPlayers
                                      )}%` }}
                                    aria-valuenow="50"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  ></div>
                                </div>
                                <span className="font-weight-bold font-size-sm mr-4">
                                {tournamentForEdit?.totalJoinedPlayers || 0} Joined User
                                </span>
                                <span className="font-weight-bold font-size-sm ml-4">
                                {parseInt(
                                  parseInt(
                                    tournamentForEdit?.totalPlayers
                                  ) - parseInt(tournamentForEdit?.totalJoinedPlayers || 0)
                                )} Remaining users
                                </span>
                              </div> */}
                    </div>

                    {/* <!--end::Progress--> */}
                  </div>
                </div>
                {/* <!--end: Info--> */}
              </div>
              {/* end::Top */}
              {/* <!--begin::Separator--> */}
              <div className="separator separator-solid my-5"></div>
              {/* <!--end::Separator--> */}
              {/* <!--begin::Bottom--> */}
              <div className="d-flex align-items-center flex-wrap">
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-event-calendar-symbol icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Tournament Registration Start Date & Time
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {tournamentForEdit?.registrationStartDate ? moment(tournamentForEdit.registrationStartDate).format("MMM DD, YYYY hh:mm a") : "-"}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-event-calendar-symbol icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Tournament Registration End Date & Time
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {tournamentForEdit?.registrationEndDate ? moment(tournamentForEdit.registrationEndDate).format("MMM DD, YYYY hh:mm a") : "-"}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-calendar-with-a-clock-time-tools icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Tournament Start Date & Time
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {tournamentForEdit?.startDate ? moment(tournamentForEdit.startDate).format("MMM DD, YYYY hh:mm a") : "-"}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-calendar-with-a-clock-time-tools icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Tournament End Date & Time
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {tournamentForEdit?.endDate ? moment(tournamentForEdit.endDate).format("MMM DD, YYYY hh:mm a") : "-"}
                    </span>
                  </div>
                </div>
              </div>
              {/* <!--end::Bottom--> */}
              {/* <!--begin::Separator--> */}
              <div className="separator separator-solid my-5"></div>
              {/* <!--end::Separator--> */}
              {/* <!--begin::Bottom--> */}
              <div className="d-flex align-items-center flex-wrap">
                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-piggy-bank icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Prize pool
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                    <CurrencyIcoon item={tournamentForEdit} />
                      {tournamentForEdit?.prizePool}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-confetti icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Entry Fee
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                    <CurrencyIcoon item={tournamentForEdit} />
                      {tournamentForEdit?.entryFee}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}

                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-pie-chart icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Entry fee collect
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      <CurrencyIcoon item={tournamentForEdit} />
                      {parseInt(
                        parseInt(tournamentForEdit?.entryFee) *
                        parseInt(tournamentForEdit?.totalJoinedPlayers)
                      )}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-pie-chart icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Winning distributed
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {/* <span className="text-dark-50 font-weight-bold">₹</span> */}
                      <CurrencyIcoon item={tournamentForEdit} />
                      {tournamentForEdit?.totalWinningsDistributed}
                    </span>
                  </div>
                </div>
                {tournamentForEdit?.winningTerm && (
                  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span className="mr-4">
                      <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                    </span>
                    <div className="d-flex flex-column flex-lg-fill">
                      <span className="text-muted font-weight-bolder font-size-sm">
                        Tournamnet Type
                      </span>
                      <span className="font-weight-bolder font-size-h5 text-dark-75">
                        {tournamentForEdit.winningTerm === "perRank" ? 'Rank' : 'Point Base'}
                      </span>
                    </div>
                  </div>
                )}
                {/* <!--end: Item--> */}
                {/* <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                          <span className="mr-4">
                            <i className="flaticon-star icon-2x text-muted font-weight-bold"></i>
                          </span>
                          <div className="d-flex flex-column">
                            <span className="text-muted font-weight-bolder font-size-sm">
                              Ratings
                            </span>
                            <span className="font-weight-bolder font-size-h5 text-dark-75">
                              5
                            </span>
                          </div>
                        </div> */}
                {/* <!--end: Item--> */}
                {/* <!--begin: Item--> */}
                {/* <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                          <span className="mr-4">
                            <i className="flaticon-warning-sign icon-2x text-muted font-weight-bold"></i>
                          </span>
                          <div className="d-flex flex-column">
                            <span className="text-muted font-weight-bolder font-size-sm">
                              Report issue
                            </span>
                            <span className="font-weight-bolder font-size-h5 text-dark-75">
                              0
                            </span>
                          </div>
                        </div> */}
                {/* <!--end: Item--> */}
              </div>
              {/* <!--end::Bottom--> */}
              {/* <!--begin::Separator--> */}
              <div className="separator separator-solid my-5"></div>
              {/* <!--end::Separator--> */}
              {/* <!--begin::Bottom--> */}
              <div className="d-flex align-items-center flex-wrap">
                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-users icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Total Registered Team
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {parseInt(tournamentForEdit?.totalJoinedTeam || 0)}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon2-check-mark icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column text-muted">
                    <span className="font-weight-bolder font-size-sm">
                      Total Approved Team
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {parseInt(tournamentForEdit?.totalApprovedTeam || 0)}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon2-cancel-music icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column flex-lg-fill">
                    <span className="text-muted font-weight-bolder font-size-sm">
                      Total Rejected Team
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {parseInt(tournamentForEdit?.totalRejectedTeam || 0)}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
              </div>
              {/* <!--end::Bottom--> */}
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 mb-10 p-0">
        <Accordion>
          {tournamentForEdit?.prizePooInfo &&
            tournamentForEdit.prizePooInfo.length > 0 ? (
            <Card>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
              >
                <CardHeader title={"Prize Pool Info"}></CardHeader>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <CardBody>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>RANK FROM</th>
                        <th>RANK TO</th>
                        <th>AMOUNT</th>
                        <th>TOTAL AMOUNT</th>
                        <th>WINNING PRIZE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tournamentForEdit.prizePooInfo.length > 0 && tournamentForEdit.prizePooInfo.map(
                        (data, indp) => (
                          <tr key={"indp" + indp}>
                            <td>{indp + 1}</td>
                            <td>{data.rankFrom}</td>
                            <td>{data.rankTo || 0}</td>
                            <td>{data.amount}</td>
                            <td>{data.totalAmount}</td>
                            <td>{"N / A"}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </CardBody>
              </Accordion.Collapse>
            </Card>
          ) : (
            <></>
          )}

          {tournamentForEdit?.pointPoolInfo &&
            tournamentForEdit.pointPoolInfo.length > 0 ? (
            <Card>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="2"
              >
                <CardHeader title={"Point Pool Info"}></CardHeader>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <CardBody>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>RANK FROM</th>
                        <th>RANK TO</th>
                        <th>POINTS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tournamentForEdit.pointPoolInfo.map(
                        (data, indp) => (
                          <tr key={"rankPointtab" + indp}>
                            <td>{indp + 1}</td>
                            <td>{data.rankFrom}</td>
                            <td>{data.rankTo}</td>
                            <td>{data.point}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </CardBody>
              </Accordion.Collapse>
            </Card>
          ) : (
            <></>
          )}

          {tournamentForEdit?.eventReportissue &&
            tournamentForEdit.eventReportissue.length > 0 && (
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="2"
                >
                  <CardHeader title={"Reported Issue"}></CardHeader>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <CardBody>
                    <table className="table table-striped table-bordered zero -configuration">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Issue</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tournamentForEdit.eventReportissue.map(
                          (issue, ind) => (
                            <tr key={`issue-key${ind}`}>
                              <th>{ind + 1}</th>
                              <th>{issue.reportIssue.issue}</th>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </CardBody>
                </Accordion.Collapse>
              </Card>
            )}

          <Card>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="1"
            >
              <CardHeader title={"Rules"}></CardHeader>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <CardBody>
                <div
                  dangerouslySetInnerHTML={{
                    __html: tournamentForEdit?.rules,
                  }}
                ></div>
              </CardBody>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    </div>
  );
}